import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {NGXLogger} from 'ngx-logger';
import {catchError, map, of, switchMap} from 'rxjs';
import {mappedHttpErrorResponseOperator} from '@adnova/jf-ng-components';
import {DatevIncometaxExportConfigService} from '../../openapi/export-openapi';
import {ExportConfigEntitiesActions} from '../actions/export-config-entities.actions';
import {AppState} from '../states/app.state';
import {ExportConfigEntity} from '../states/export-config-entities.state';


@Injectable()
export class ExportConfigEntitiesEffects {

  private actions$ = inject(Actions);
  private store = inject(Store<AppState>);
  private logger = inject(NGXLogger);
  private exportConfigService = inject(DatevIncometaxExportConfigService);

  /**
   * Load export configs for a single firma (detail page)
   * Always loads fresh data from backend on each request
   */
  readonly loadExportConfigsForFirma$ = createEffect(
    () => this.actions$.pipe(
      ofType(ExportConfigEntitiesActions.loadExportConfigsForFirma),
      switchMap((action) => {
        this.logger.debug(`Loading export configs for firma ${action.firmaId}`);

        return this.exportConfigService.getExportConfigsForFirma(action.firmaId).pipe(
          map(response => {
            const configs = response.exportConfigs.map(config => ({
              ...config,
              firmaId: action.firmaId,
            } as ExportConfigEntity));

            this.logger.debug(`Loaded ${configs.length} export configs for firma ${action.firmaId}`);
            return ExportConfigEntitiesActions.loadExportConfigsSuccess({exportConfigs: configs});
          }),
          catchError(error => of(error).pipe(
            mappedHttpErrorResponseOperator(error),
            map(error => {
              this.logger.error(`Failed to load export configs for firma ${action.firmaId}:`, error);
              return ExportConfigEntitiesActions.loadExportConfigsFailure({error});
            })
          ))
        );
      })
    )
  );

  /**
   * Log failure
   */
  readonly loadExportConfigsFailure$ = createEffect(
    () => this.actions$.pipe(
      ofType(ExportConfigEntitiesActions.loadExportConfigsFailure),
      map(action => {
        this.logger.error('Export config loading failed:', action.error);
      })
    ),
    {dispatch: false}
  );
}
